import { render, staticRenderFns } from "./bulkUpload.vue?vue&type=template&id=fa75f39a&scoped=true&"
import script from "./bulkUpload.vue?vue&type=script&lang=js&"
export * from "./bulkUpload.vue?vue&type=script&lang=js&"
import style0 from "./bulkUpload.vue?vue&type=style&index=0&id=fa75f39a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa75f39a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VCol,VImg,VRow,VSimpleTable})
